// http 请求超时时间
export const HTTP_TIMEOUT = 30000
// http 基准路由
export const HTTP_BASEURL = process.env.REACT_APP_HTTP_BASEURL
